type Endpoint =
  | "Users2Roles"
  | "Modules2Roles"
  | "Templates2Roles"
  | "Users2NotificationTemplates";

const createGetUP = (endpoint: Endpoint) => (xId: number) =>
  `api/${endpoint}/X2Y/${xId}`;
const createUpdateUP = createGetUP;
const createBulkGetUP = (endpoint: Endpoint) => () =>
  `api/${endpoint}/GetBulkX2y`;
const createBulkUpdateUP = (endpoint: Endpoint) => () =>
  `api/${endpoint}/EditBulkX2y`;

const createUrlParsers = (endpoint: Endpoint) => ({
  get: createGetUP(endpoint),
  update: createUpdateUP(endpoint),
  getBulk: createBulkGetUP(endpoint),
  updateBulk: createBulkUpdateUP(endpoint),
});

export type UrlParsers = ReturnType<typeof createUrlParsers>;

export const users2Roles = createUrlParsers("Users2Roles");
export const modules2Roles = createUrlParsers("Modules2Roles");
export const templates2Roles = createUrlParsers("Templates2Roles");
export const users2NotificationTemplates = createUrlParsers(
  "Users2NotificationTemplates"
);
